import type { IStoreSelectedFacet } from '@faststore/api'

import type { Facet, FacetValue } from '../types'
import Switch from '../Switch'

type BlueProductFilterProps = {
  blueProduct?: Facet
  onFacetChange?: (
    item: IStoreSelectedFacet,
    type?: 'RANGE' | 'BOOLEAN'
  ) => void
}

const BlueProductFilter = ({
  blueProduct,
  onFacetChange,
}: BlueProductFilterProps) => {
  if (!blueProduct || typeof onFacetChange !== 'function') {
    return null
  }

  const blueProductValue = blueProduct?.values?.find(
    (value) => value.label.toLocaleLowerCase() === 'true'
  ) as FacetValue

  return (
    <div
      key={blueProduct.key}
      className="p-4 pl-[21px] main-filters rounded font-inter !border-l-[5px] !border-l-blueProductAccent border-gray border"
    >
      <Switch
        testId={`desktop-${blueProduct.key}`}
        facet={blueProduct}
        facetValue={blueProductValue}
        onFacetChange={onFacetChange}
      >
        <div className="flex items-center">
          <div className="flex flex-col gap-[2px] max-w-[318px] md:max-w-none">
            <h2 className="text-[14px] leading-[21px] text-neutral11 font-semibold">
              Melhor custo benefício
            </h2>
            <p className="text-xs leading-[18px] text-tertiary">
              Produtos que oferecem o melhor entre{' '}
              <strong className="font-bold inline">
                desempenho, qualidade e preço.
              </strong>
            </p>
          </div>
        </div>
      </Switch>
    </div>
  )
}

export default BlueProductFilter
